module.exports = __webpack_public_path__ + "static/media/silver.c2c34079.webp";